import "../../index30.css";
import { jsx as t } from "react/jsx-runtime";
import { _ as n } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import y from "../InlineLayout/index.js";
const b = "_inline-view_107r9_1", g = "_with-wrap_107r9_2", L = "_inline-layout_107r9_8", V = "_before-content_107r9_9", W = "_after-content_107r9_17", e = {
  inlineView: b,
  withWrap: g,
  inlineLayout: L,
  beforeContent: V,
  afterContent: W
};
function P(i) {
  const {
    layoutElementRef: a,
    layoutClassName: o,
    className: r,
    elementRef: s,
    before: l,
    beforeContainerClassName: f,
    children: c,
    childrenContainerClassName: m,
    after: C,
    afterContainerClassName: _,
    spacing: p,
    spacingOffset: w,
    withPadding: u,
    withoutSpacingOpticalCorrection: h,
    withoutWrap: N = !1,
    ...d
  } = i;
  return /* @__PURE__ */ t(
    "div",
    {
      ...d,
      ref: s,
      className: n(
        e.inlineView,
        !N && e.withWrap,
        r
      ),
      children: /* @__PURE__ */ t(
        y,
        {
          className: n(e.inlineLayout, o),
          elementRef: a,
          before: l,
          beforeContainerClassName: n(e.beforeContent, f),
          childrenContainerClassName: m,
          after: C,
          afterContainerClassName: n(e.afterContent, _),
          spacing: p,
          spacingOffset: w,
          withPadding: u,
          withoutSpacingOpticalCorrection: h,
          children: c
        }
      )
    }
  );
}
export {
  P as default
};
